var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isEditable ? _vm.hasBrowsePagePermission : _vm.hasEditPagePermission)?_c('el-switch',{attrs:{"value":_vm.isEditable,"active-text":"編集","active-color":"#1976d2","inactive-text":"閲覧","inactive-color":"#16b94f"},on:{"change":_vm.handleModeChange}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }